import { useEffect, useState } from "react";
import "./VendorDetails.css";
import { makeApiCall } from "../Api/makeApiCall";
import { Api_Endpoints } from "../Api/apiEndpoint";
import { showErrorToast, showSuccessToast } from "../utils/toastService";
import { useLocation, useNavigate } from 'react-router-dom';
import ImageModal from "./VendorViewPage/ImageModal";
import { CheckCircle, XCircle, Download, Check, Clock } from "lucide-react";
import CommentModal from "./VendorViewPage/CommentModal";
import { hover } from "@testing-library/user-event/dist/hover";
import { getUserSession } from "../utils/auth";

// Modal for comment input

const VendorSavedDraftDetails = () => {
  const user_data = getUserSession(); // Get user session to determine roles
  console.log(user_data?.user, 'User Data');
  // const navigate= useNavigate() ;

  const location = useLocation();
  const navigate = useNavigate()
  const VendorID = location?.state?.VendorID;
  const [checkerDocumentStatuses, setCheckerDocumentStatuses] = useState(() => {
    return JSON.parse(localStorage.getItem(`checker-documentStatuses-${VendorID}`) || '{}');
  });

  const [checker1DocumentStatuses, setChecker1DocumentStatuses] = useState(() => {
    return JSON.parse(localStorage.getItem(`checker1-documentStatuses-${VendorID}`) || '{}');
  });
  const [checkerViewedDocuments, setCheckerViewedDocuments] = useState(() => {
    return new Set(JSON.parse(localStorage.getItem(`checker-viewedDocuments-${VendorID}`) || '[]'));
  });

  const [checker1ViewedDocuments, setChecker1ViewedDocuments] = useState(() => {
    return new Set(JSON.parse(localStorage.getItem(`checker1-viewedDocuments-${VendorID}`) || '[]'));
  });

  const [documentStatuses, setDocumentStatuses] = useState(() => {
    return JSON.parse(localStorage.getItem(`${user_data?.user}-documentStatuses-${VendorID}`) || '{}');
  });

  const [viewedDocuments, setViewedDocuments] = useState(() => {
    return new Set(JSON.parse(localStorage.getItem(`${user_data?.user}-viewedDocuments-${VendorID}`) || '[]'));
  });
  const [details, setDetails] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState('');


  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [status, setstatus] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [comment, setComment] = useState('');


  const handleApproveDocument = (documentType, statusField) => {
    setDocumentStatuses(prev => ({
      ...prev,
      [documentType]: "APPROVED"
    }));
    localStorage.setItem(
      `${user_data?.user}-documentStatuses-${VendorID}`,
      JSON.stringify({
        ...documentStatuses,
        [documentType]: "APPROVED"
      })
    );
  };
  const handleRejectDocument = (documentType, statusField) => {
    setDocumentStatuses(prev => ({
      ...prev,
      [documentType]: "REJECTED"
    }));
    localStorage.setItem(
      `${user_data?.user}-documentStatuses-${VendorID}`,
      JSON.stringify({
        ...documentStatuses,
        [documentType]: "REJECTED"
      })
    );
  };

  const getDocumentAPIStatus = (documentType, statusField) => {
    const fieldName = getStatusFieldName(statusField);
    console.log("389iu: ", fieldName);

    return details[fieldName];
  };


  const [getDocument, setGetDocument] = useState("");
  const [ApprovedDoc, setApprovedDoc] = useState("")
  const [count, setCount] = useState(true)

  const getStatusFieldName = (baseField) => {
    if (user_data?.user === 'Checker') {
      return `sec_${baseField}`;
    }
    return baseField;
  };

  const handleModal = (action) => {
    setCommentModalOpen(true)
    setstatus(action)
  }


  const data = useLocation();


  const checkAllDocumentsStatus = () => {
    const ApprovedStatuses = {};

    if (documentStatuses && typeof documentStatuses === "object") {
      Object.entries(documentStatuses).forEach(([key, value]) => {
        if (value === "APPROVED") {
          ApprovedStatuses[key] = value;
        }
      });

      setApprovedDoc(Object.keys(ApprovedStatuses).length);
    }

    return ApprovedStatuses;
  };

  console.log(documentStatuses, ">>>>>DOCUMENT STATUS")


  const editVendor = () => {
    console.log(details.id, "ID FROM VENDOR DETAILS PAGE")
    navigate('/View-Vendor', {
      state: {
        VendorID: details.vendor_id,
        isDraft: true 
      }
    })



  }

  useEffect(() => {
    checkAllDocumentsStatus();
  }, [documentStatuses, viewedDocuments]);

  useEffect(() => {
    const condition = ApprovedDoc !== getDocument || (ApprovedDoc === 0 && getDocument === 0);
    setCount(condition);
  }, [getDocument, ApprovedDoc]);

  useEffect(() => {
    localStorage.setItem(`${user_data?.user}-documentStatuses-${VendorID}`, JSON.stringify(documentStatuses));
  }, [documentStatuses, VendorID, user_data?.user]);

  useEffect(() => {
    localStorage.setItem(`${user_data?.user}-viewedDocuments-${VendorID}`, JSON.stringify([...viewedDocuments]));
  }, [viewedDocuments, VendorID, user_data?.user]);


  const handleActionClick = (adminComment) => {
    //setConfirmationType(actionType);
    setShowConfirmation(true);
    setComment(adminComment)
    //setstatus(actionType === 'Approved' ? 'Approved' : 'REFER-BACK');
    //setCommentModalOpen(true);
  };



  const [checkerStatus, setCheckerStatus] = useState(() => {
    return JSON.parse(localStorage.getItem(`checker-status-${VendorID}`) || '{}');
  });

  const [checker1Status, setChecker1Status] = useState(() => {
    return JSON.parse(localStorage.getItem(`checker1-status-${VendorID}`) || '{}');
  });




  const handleConfirmAction = async () => {

    const check2 = {
      vendor_id: VendorID,
      comments: comment,
      action: status,
      sec_address_approved: documentStatuses.url_upload_address_proof || "PENDING",
      sec_cin_approved: documentStatuses.url_upload_cin_no || "PENDING",
      sec_moa_approved: documentStatuses.url_upload_moa_form || "PENDING",
      sec_aoa_approved: documentStatuses.url_upload_aoa_form || "PENDING",
      sec_pan_approved: documentStatuses.url_upload_pan_no || "PENDING",
      sec_gst_approved: documentStatuses.url_upload_gst_certificate || "PENDING",
      sec_agreement_approved: documentStatuses.url_upload_agreement || "PENDING",
      sec_cancelled_approved: documentStatuses.url_upload_cancelled_bank || "PENDING",

    };

    const payload = {
      vendor_id: VendorID,
      comments: comment,
      action: status,
      address_approved: documentStatuses.url_upload_address_proof || "PENDING",
      cin_approved: documentStatuses.url_upload_cin_no || "PENDING",
      moa_approved: documentStatuses.url_upload_moa_form || "PENDING",
      aoa_approved: documentStatuses.url_upload_aoa_form || "PENDING",
      pan_approved: documentStatuses.url_upload_pan_no || "PENDING",
      gst_approved: documentStatuses.url_upload_gst_certificate || "PENDING",
      agreement_approved: documentStatuses.url_upload_agreement || "PENDING",
      cancelled_approved: documentStatuses.url_upload_cancelled_bank || "PENDING"
    };


    const content = user_data?.user === "Checker" ? check2 : payload;

    console.log(content, "Content")

    const response = await makeApiCall(Api_Endpoints.VENDOR_ACTION, 'POST', content);

    if (response?.status) {
      showSuccessToast(response?.message);
      localStorage.removeItem(`${user_data?.user}-documentStatuses-${VendorID}`);
      localStorage.removeItem(`${user_data?.user}-viewedDocuments-${VendorID}`);
      setShowConfirmation(false);
      setCommentModalOpen(false);
      navigate("/Vendors");
    } else {
      showErrorToast(response?.message);
      setShowConfirmation(false);
    }
  };



  const DocumentRow = ({ label, url, filename, documentType, statusField }) => {


    const apiStatus = getDocumentAPIStatus(documentType, statusField);


    const currentStatus = documentStatuses[documentType] || apiStatus || "Pending";

    return (
      <tr>
        <td>
          <strong>{label}</strong>
        </td>
        <td className="flex items-start gap-2">
          {url && filename ? (
            <span
              onClick={() => openModal(url, documentType)}
              className="hover:text-blue-600 cursor-pointer"
              style={{ cursor: "pointer", color: "blue" }}
            >
              {filename}
            </span>
          ) : (
            <p>NA</p>
          )}
        </td>
        {url && filename && user_data?.user !== 'Maker' && (
          <>
            <td className="flex items-center gap-4">
              <CheckCircle
                style={{
                  width: "1.25rem",
                  height: "1.25rem",
                  cursor: viewedDocuments.has(documentType) ? "pointer" : "not-allowed",
                  color: currentStatus === "APPROVED" ? "green" : "blue",
                }}
                onClick={() =>
                  viewedDocuments.has(documentType)
                    ? handleApproveDocument(documentType, statusField)
                    : showErrorToast("Please View Document")
                }
              />
              <XCircle
                style={{
                  width: "1.25rem",
                  height: "1.25rem",
                  cursor: viewedDocuments.has(documentType) ? "pointer" : "not-allowed",
                  color: currentStatus === "REJECTED" ? "red" : "blue",
                }}
                onClick={() =>
                  viewedDocuments.has(documentType)
                    ? handleRejectDocument(documentType, statusField)
                    : showErrorToast("Please View Document")
                }
              />
            </td>
            <td>
              <span
                style={{
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  color:
                    currentStatus === "APPROVED"
                      ? "green"
                      : currentStatus === "REJECTED"
                        ? "red"
                        : "blue",
                }}
              >
                {currentStatus}
              </span>
            </td>
          </>
        )}
      </tr>
    );
  };




  const GetDetails = async () => {
    const response = await makeApiCall(Api_Endpoints.VENDOR_SAVE_DRAFT_DETAILS, 'POST', { vendor_id: VendorID });
    if (response?.status) {
      setDetails(response.result.vendor_details);
    } else {
      showErrorToast(response?.message);
    }
  };

  

  const keysToVerify = [
    "upload_address_proof",
    "url_upload_aoa_form",
    "url_upload_moa_form",
    "url_upload_cin_no",
    "url_upload_cancelled_bank",
    "url_upload_pan_no",
    "url_upload_gst_certificate",
    "url_upload_agreement"
  ];



  useEffect(() => {
    if (details) {
      const keysToVerify = [
        "url_upload_address_proof",
        "url_upload_aoa_form",
        "url_upload_moa_form",
        "url_upload_cin_no",
        "url_upload_cancelled_bank",
        "url_upload_pan_no",
        "url_upload_gst_certificate",
        "url_upload_agreement"
      ];

      const availableDocuments = keysToVerify.filter(key =>
        details[key] !== "" && details[key] !== null && details[key] !== undefined
      );

      setGetDocument(availableDocuments.length);
    }
  }, [details]);

  const openModal = (url, documentType) => {
    window.open(url);
    // setSelectedImageUrl(url);
    setIsModalOpen(false);
    const updatedViewedDocs = new Set([...viewedDocuments, documentType]);
    setViewedDocuments(updatedViewedDocs);
    localStorage.setItem(
      `${user_data?.user}-viewedDocuments-${VendorID}`,
      JSON.stringify([...updatedViewedDocs])
    );
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImageUrl('');
  };


  const checkReferBackStatus = () => {
    return viewedDocuments.size >= 1;
  };

  const sendApprovalData = async (comments) => {
    const approvalData = {
      vendor_id: VendorID,
      document_statuses: documentStatuses,
      comments: comments,
      action: status
    };


    const response = await makeApiCall(Api_Endpoints.VENDOR_ACTION, 'POST', approvalData);
    if (response?.status) {
      showSuccessToast(response?.message);
      localStorage.removeItem(`documentStatuses-${VendorID}`);
      localStorage.removeItem(`viewedDocuments-${VendorID}`);
    } else {
      showErrorToast(response?.message);
    }
  };

  useEffect(() => {
    GetDetails();
  }, []);

  useEffect(() => {
    // Disable if the values are not equal or if both are zero
    const condition = ApprovedDoc !== getDocument || (ApprovedDoc === 0 && getDocument === 0);
    setCount(condition); // Update the state to reflect the disabled condition
  }, [getDocument, ApprovedDoc]);

  useEffect(() => {
    if (user_data?.user === 'Checker') {
      localStorage.setItem(`checker-documentStatuses-${VendorID}`,
        JSON.stringify(checkerDocumentStatuses));
      localStorage.setItem(`checker-viewedDocuments-${VendorID}`,
        JSON.stringify([...checkerViewedDocuments]));
    }
  }, [checkerDocumentStatuses, checkerViewedDocuments]);

  useEffect(() => {
    if (user_data?.user === 'Checker1') {
      localStorage.setItem(`checker1-documentStatuses-${VendorID}`,
        JSON.stringify(checker1DocumentStatuses));
      localStorage.setItem(`checker1-viewedDocuments-${VendorID}`,
        JSON.stringify([...checker1ViewedDocuments]));
    }
  }, [checker1DocumentStatuses, checker1ViewedDocuments]);


  useEffect(() => { }, [status])
  useEffect(() => {
    localStorage.setItem(`documentStatuses-${VendorID}`, JSON.stringify(documentStatuses));
  }, [documentStatuses, VendorID]);

  useEffect(() => {
    localStorage.setItem(`viewedDocuments-${VendorID}`, JSON.stringify([...viewedDocuments]));
  }, [viewedDocuments, VendorID]);

  return (
    <div>

      <div className="report-section">
        <h2>Vendor Details</h2>

        <table className="data-table">

          <tbody>
            <tr>

              {/* <td>{isEditing ? <input type="text" className='edit_details_Form'  name="proposal_no" value={editableData.proposal_no} onChange={handleChange} /> : reportData?.proposal_detail?.proposal_no}</td> */}
              <td><strong>Vendor Name</strong></td>
              <td>{details.name}</td>
              <td><strong>Vendor Id</strong></td>
              <td>{details.vendor_id}</td>

            </tr>

            <tr>
              <td><strong> Email</strong></td>
              <td>{details.email}</td>
              <td><strong>Mobile No</strong></td>
              <td>{details.mobile_no}</td>
            </tr>
            <tr>

            </tr>
            <tr>
              <td><strong>Vendor Status</strong></td>
              <td>{details.vendor_status}</td>
              <td><strong>Nature of business</strong></td>
              <td>{details.nature_of_business ?? 'NA'}</td>



            </tr>

            <tr>
              <td><strong>PAN No</strong></td>
              <td>{details.pan_no ?? 'NA'}</td>
              <td><strong>GST No</strong></td>
              <td>{details.gst_no ?? 'NA'}</td>
            </tr>
            <tr>
              <td><strong>CIN No</strong></td>
              <td>{details.cin_no ?? 'NA'}</td>
              <td><strong>Address proof type</strong></td>
              <td>{details.address_proof_type}</td>
            </tr>



            <tr>
              <td><strong>Address</strong></td>
              <td>{details.address ?? 'NA'}</td>

              <td><strong>Pin Code </strong></td>
              <td>{details.pincode ?? 'NA'}</td>



            </tr>
            <tr>


              <td><strong>State</strong></td>
              <td>{details.state ?? 'NA'}</td>
              <td><strong>City</strong></td>
              <td>{details.city ?? 'NA'}</td>

            </tr>

            {user_data?.user !== 'Maker' && (
              <tr>
                <td><strong>Invoice Count</strong></td>
                <td>{details.invoice_count ?? 'NA'}</td>

              </tr>)}



          </tbody>
        </table>
      </div>


      <div className="report-section">
        <h2>Authorized Signatory Details</h2>
        <table className="data-table">
          <tbody>
            <tr>
              <td><strong>Name</strong></td>
              <td>{details.authorized_signatory ?? 'NA'}</td>
              <td><strong>Mobile no</strong></td>
              <td>{details.authorized_signatory_mobile_no ?? 'NA'}</td>
              <td><strong>Email</strong></td>
              <td>{details.authorized_signatory_email ?? 'NA'}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="report-section">
        <h2>Vendor bank details</h2>
        <table className="data-table">
          <tbody>
            <tr>
              <td><strong>Account No</strong></td>
              <td>{details.account_no ?? 'NA'}</td>
              <td><strong>Account Holder Name</strong></td>
              <td>{details.account_holder_name ?? 'NA'}</td>
              <td><strong>IFSC Code</strong></td>
              <td>{details.ifsc_code ?? 'NA'}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {(user_data?.user === 'Checker' && details.vendor_status !== 'APPROVED') && details?.approved_by_username && (
        <div className="report-section">

          <>
            <h2>Approval Status</h2>
            <div className="invoice-section">
              <table className="invoice-table">
                <thead>
                  <tr>
                    <th><strong>Name</strong></th>
                    <th><strong>Status</strong></th>
                    <th><strong>Date</strong></th>
                    <th><strong>Email</strong></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{details.approved_by_username}</td>
                    <td>
                      <div className="flex items-center gap-2 approval-status">
                        {details.vendor_status === 'APPROVED' ? (
                          <CheckCircle className="text-green-500 CheckCircle" size={16} />
                        ) : details.vendor_status === 'REFER-BACK' ? (
                          <XCircle className="text-red-500 XCircle" size={16} />
                        ) : (
                          <Clock className="text-blue-500 Clock" size={16} />
                        )}
                        <span className={`status-text ${details.vendor_status === 'APPROVED' ? 'status-approved' :
                          details.vendor_status === 'REFER-BACK' ? 'status-referred' :
                            'status-pending'
                          }`}>
                          {details.vendor_status}
                        </span>
                      </div>
                    </td>
                    <td>{new Date(details.updated_at).toLocaleDateString()}</td>
                    <td>{details.approved_by_email}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>

        </div>
      )}
      <div className="report-section">
        <h2>Vendor Classification</h2>
        <table className="data-table">
          <tr>
            <td><strong>Vendor type </strong></td>
            <td>{details.vendor_type ?? 'NA'}</td>

            <td><strong>Vendor Category</strong></td>
            <td>{details.vendor_category ?? 'NA'}</td>

          </tr>
          <tr>
            <td><strong>Payment  Term </strong></td>
            <td>{details.payment_term ?? 'NA'}</td>
            <td><strong>Vendor Referral code </strong></td>
            <td>{details.vendor_referral_code
            }</td>
          </tr>
          <tr>
            <td><strong>Agreement Status</strong></td>
            <td >{details.agreement_status ?? 'NA'}</td>

            <td><strong>Agreement Type</strong></td>
            <td>{details.agreement_type ?? 'NA'}</td>


          </tr>
          <tr>
            <td><strong>Agreement Start Date</strong></td>
            <td>{details.agreement_start_date ?? 'NA'}</td>
            <td><strong>Agreement End Date</strong></td>
            <td >{details.agreement_end_date ?? 'NA'}</td>


          </tr>
        </table>
      </div>
      <div className="report-section">
        <h2>Vendor Compliances</h2>
        <table className="data-table">
          <tr>
            <td><strong>TDS ELIGIBLE</strong></td>
            <td>{details.tds_type ?? 'NA'}</td>
            <td><strong>TDS Rate</strong></td>
            <td>{details.tds_rate ?? 'NA'}</td>
          </tr>
          <tr>
            <td><strong>GST ELIGIBLE</strong></td>
            <td>{details.gst_type ?? 'NA'}</td>
            <td><strong>GST Rate</strong></td>
            <td>{details.gst_rate ?? 'NA'}</td>
          </tr>
        </table>
      </div>

      {(user_data?.user === 'Checker' || user_data?.user === "Checker1" || user_data?.user === "Maker") && (
        <div className="report-section">
          <h2>Vendor Documents</h2>
          <table className="data-table vendor-documents">
            <tbody>
              <DocumentRow
                label="Address Proof"
                url={details.url_upload_address_proof}
                filename={details.upload_address_proof}
                documentType="url_upload_address_proof"
                statusField="address_approved"
              />

              <DocumentRow
                label=" Cancelled Cheque Document"
                url={details.url_upload_cancelled_bank}
                filename={details.upload_cancelled_bank}
                documentType="url_upload_cancelled_bank"
                statusField="cancelled_approved"
              />
              <DocumentRow
                label="PAN Document"
                url={details.url_upload_pan_no}
                filename={details.upload_pan_no}
                documentType="url_upload_pan_no"
                statusField="pan_approved"
              />
              <DocumentRow
                label="GST Document"
                url={details.url_upload_gst_certificate}
                filename={details.upload_gst_certificate}
                documentType="url_upload_gst_certificate"
                statusField="gst_approved"
              />
              <DocumentRow
                label="Agreement Document"
                url={details.url_upload_agreement}
                filename={details.upload_agreement}
                documentType="url_upload_agreement"
                statusField="agreement_approved"
              />
              <DocumentRow
                label="CIN Document"
                url={details.url_upload_cin_no}
                filename={details.upload_cin_no}
                documentType="url_upload_cin_no"
                statusField="cin_approved"
              />
              <DocumentRow
                label="AOA Document"
                url={details.url_upload_aoa_form}
                filename={details.upload_aoa_form}
                documentType="url_upload_aoa_form"
                statusField="aoa_approved"
              />
              <DocumentRow
                label="MOA Document"
                url={details.url_upload_moa_form}
                filename={details.upload_moa_form}
                documentType="url_upload_moa_form"
                statusField="moa_approved"
              />



            </tbody>
          </table>
        </div>
      )}

      {(user_data?.user === 'Maker' || user_data?.user === 'Checker' || user_data?.user === 'Checker1') && (
        <div className="report-section">
          <h2>Remarks</h2>
          <table className="data-table">
            <tbody>
              <tr>



                <td><strong>Remarks First</strong></td>
                <td>{details.remark_first ?? 'NA'}</td>
                <td><strong>Remarks Second</strong></td>
                <td>{details.remark_sec}</td>


              </tr>
            </tbody>
          </table>
        </div>
      )}
      {((user_data?.user === 'Checker1' && details.vendor_status === 'PENDING') ||
        (user_data?.user === 'Checker' && details.vendor_status === 'PARTIAL APPROVED')) && (
          <div>
            <div className="button-status">
              <button
                className="Approved-button"
                disabled={count}
                onClick={() => handleModal('APPROVED')}
              >
                Approve
              </button>
              <button
                className="Reffered-button"
                disabled={viewedDocuments.size === 0}
                onClick={() => handleModal('REFER-BACK')}
              >
                Refer-Back
              </button>
            </div>
          </div>
        )}

      <ImageModal
        isOpen={isModalOpen}
        onClose={closeModal}
        imageUrl={selectedImageUrl}
      />

      {showConfirmation && (
        <div className="confirmation-dialog">
          <div className="confirmation-content">
            <p>
              {status === 'APPROVED'
                ? 'Are you sure you want to approve?'
                : 'Are you sure you want to refer back?'}
            </p>
            <button onClick={() => handleConfirmAction()}>Yes</button>
            <button onClick={() => setShowConfirmation(false)}>No </button>
          </div>
        </div>
      )}

      <CommentModal
        isOpen={commentModalOpen}
        onClose={() => {
          setCommentModalOpen(false);
          // setShowConfirmation(false);
        }}
        onSubmit={(adminComment) => handleActionClick(adminComment)}
      />
      {(details.vendor_status_id === 1 && user_data?.user === "Maker") && (
        <button
          className="Approved-button"
          onClick={() => editVendor()}>
          Edit Vendor
        </button>
      )}
      {(user_data?.user === 'Account' && details.vendor_status === "APPROVED") && (
        <button
          className="Approved-button"

          onClick={() => navigate('/InvoiceDetails', {
            state: {
              VendorID: details.vendor_id
            }
          })}>
          Add Invoice
        </button>
      )}
    </div>
  );
};

export default VendorSavedDraftDetails;


